import { render } from "./DetailsRestaurant.vue?vue&type=template&id=53f368f4"
import script from "./DetailsRestaurant.vue?vue&type=script&lang=js"
export * from "./DetailsRestaurant.vue?vue&type=script&lang=js"

import "./DetailsRestaurant.vue?vue&type=style&index=0&id=53f368f4&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__